import * as Sentry from '@sentry/browser';
import { Dedupe, ExtraErrorData } from '@sentry/integrations';

Sentry.Integrations.Dedupe = Dedupe;
Sentry.Integrations.ExtraErrorData = ExtraErrorData;

export default Sentry;
